/* @flow */

import classNames from 'classnames';
import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import styles from './NotificationBadge.style';

type Props = {
  layoutClass?: string,
  variant?: typeof small,
};

const useStyles = createUseThemeStyles(styles);

const NotificationBadge = ({ layoutClass, variant }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles();

  const rootClasses = classNames(classes.root, layoutClass, {
    [classes['root-small']]: variant === small,
  });

  /*
   |------------------------------------------------------------------------------
   | Elements
   |------------------------------------------------------------------------------
   */

  return <span className={rootClasses} />;
};

export const small = Symbol();

export default React.memo<Props>(NotificationBadge);
